import { useMemo } from 'react'

export const useAdminSecuritySlice = <
  TSessions,
  TLoadSessions,
  TTrustSession,
  TRevokeSession,
  TTeamMembers,
  TRoleDefinitions,
  TCapabilityDefinitions,
  TSectionDefinitions,
  TLoadTeam,
  TCreateUser,
  TCreateRole,
  TUpdateUserRoles,
  TCurrentSession,
>({
  sessions,
  sessionsLoading,
  loadSessions,
  trustSession,
  revokeSession,
  teamMembers,
  roleDefinitions,
  capabilityDefinitions,
  sectionDefinitions,
  teamLoading,
  loadTeam,
  createUser,
  createRole,
  updateUserRoles,
  currentSession,
}: {
  sessions: TSessions
  sessionsLoading: boolean
  loadSessions: TLoadSessions
  trustSession: TTrustSession
  revokeSession: TRevokeSession
  teamMembers: TTeamMembers
  roleDefinitions: TRoleDefinitions
  capabilityDefinitions: TCapabilityDefinitions
  sectionDefinitions: TSectionDefinitions
  teamLoading: boolean
  loadTeam: TLoadTeam
  createUser: TCreateUser
  createRole: TCreateRole
  updateUserRoles: TUpdateUserRoles
  currentSession: TCurrentSession
}) =>
  useMemo(
    () => ({
      sessions,
      sessionsLoading,
      loadSessions,
      trustSession,
      revokeSession,
      teamMembers,
      roleDefinitions,
      capabilityDefinitions,
      sectionDefinitions,
      teamLoading,
      loadTeam,
      createUser,
      createRole,
      updateUserRoles,
      currentSession,
    }),
    [
      capabilityDefinitions,
      createRole,
      createUser,
      currentSession,
      loadSessions,
      loadTeam,
      revokeSession,
      roleDefinitions,
      sectionDefinitions,
      sessions,
      sessionsLoading,
      teamLoading,
      teamMembers,
      trustSession,
      updateUserRoles,
    ],
  )
